import { render, staticRenderFns } from "./alumno-registro.vue?vue&type=template&id=5d9cbbbe&"
import script from "./alumno-registro.component.ts?vue&type=script&lang=ts&"
export * from "./alumno-registro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports